import React from "react";
import logo from "../images/logo.png"
import { Link } from "react-router-dom";
import "./Components.css"
import Home from "../pages/Home/home";


export function Title(){
    return(
        <div className="title-container">
            <div className="a">
                <h1 className="title">COLORANTÍ <img src={logo} alt="colorantí logo" className="title-logo"/> </h1>
                {/* <img src={logo} alt="colorantí logo" className="title-logo"/> */}
            </div>
            <div>
                {/* <p className="slogan">MORALLY CODED | TECHNICALLY SOUND</p> */}
            </div>            
        </div>
    )
}
export function comparison(){
        const searchParams = new URLSearchParams(window.location.search);
        const parameterValue = searchParams.get('key1');

        const dataToSend = {key1: parameterValue};
        const queryString = new URLSearchParams(dataToSend).toString();
        const url = `/vector?${queryString}`;
        window.location.href = url
}
export function Navbar(){

    //change each link to just a button that runs its own function and does the following...
    const searchParams = new URLSearchParams(window.location.search);
    const parameterValue = searchParams.get('key1');

    function home(){
        const dataToSend = {key1: parameterValue};
        const queryString = new URLSearchParams(dataToSend).toString();
        const url = `/?${queryString}`;
        window.location.href = url
    }

    function demo(){
        const dataToSend = {key1: parameterValue};
        const queryString = new URLSearchParams(dataToSend).toString();
        const url = `/demo?${queryString}`;
        window.location.href = url
    }

    function comparison(){
        const dataToSend = {key1: parameterValue};
        const queryString = new URLSearchParams(dataToSend).toString();
        const url = `/vector?${queryString}`;
        window.location.href = url
    }

    function about(){
        window.location.href = "https://colorantiteam.com/"
    }

    return(
        <nav className="demo-nav">
                <button className="demo-nav-child-2" onClick={home}>HOME</button>
                <button className="demo-nav-child-2" onClick={about}>ABOUT US</button>
                <button className="demo-nav-child-2" onClick={demo}>DEMONSTRATION</button>
                <button className="demo-nav-child-2" onClick={comparison}>What it Protects Against</button>
        </nav>  
    )
}
